import React, { useEffect } from "react";
import {
    closeSharingMenu,
    copyToClipboard,
    navBarToggle,
    openSharingMenu,
    startDownloadingPdf,
    stopDownloadingPdf,
    toggleSharingMenu,
} from "../../../redux/actions/navigation";
import { connect } from "react-redux";
import NewsletterSections from "./NewsletterSections";
import CustomSections from "./CustomSections";
import { PDFExport } from "@progress/kendo-react-pdf";

import {
    getCurrentArticleDomNode,
    getCurrentArticleIdBeingScrolled,
    getCurrentArticleScroll,
    getCurrentArticleScrollAnalysisId,
    getCurrentArticleScrollExcerptRaw,
    getCurrentArticleScrollLanguage,
    getCurrentArticleScrollLanguageisRightToLeft,
    getCurrentArticleScrollOutlet,
    getCurrentArticleScrollRawUrl,
    getCurrentArticleScrollTitle,
    getCurrentArticleScrollTitleRaw,
    getCurrentArticleScrollUrl,
    getIsClipboardCopying,
    getIsNavBarOpen,
    getIsPdfDownloading,
    getIsSharingMenuOpen,
    getUrlAccessKey,
    getCurrentArticleScrollBestLicense,
    getCurrentArticleScrollLicenseFeedUrl,
} from "../../../redux/selectors/navigation";
import Article from "./Article";
import {
    getNewsletterAccentColor,
    getNewsletterFontFamily,
    getNewsletterUseCustomFormat,
    shouldIncludeCopyLink,
    shouldIncludeDownloadPdf,
    shouldIncludeEmail,
    shouldIncludeFacebook,
    shouldIncludeLinkedIn,
    shouldIncludeTwitter,
} from "../../../redux/selectors/template";
import { Element } from "react-scroll";
import { withRouter } from "react-router-dom";
import { getRouterStateHashArticleGroupingId } from "../../../redux/selectors/router";
import { getSpaceToFillBottom, isMobile } from "../../../util/screen";

import { baseUrl } from "../../../util/service";

import { pingOnDownload } from "@publicrelay/service/dist/nest/newsletters";

let pdfCanvasReference;

/**
 * Top level Content Pane compoent (right side)
 * @param props
 * @returns {*}
 * @constructor
 */
const ContentPane = (props) => {
    const { isNavBarOpen, isMobile } = props;
    const closedClass = isNavBarOpen && isMobile ? "closed" : "";
    return (
        <div
            className={`${closedClass} nest-main`}
            onClick={props.onContentClicked}
        >
            <TopBar props={props} />
            <Element name={"top"}>
                <div>
                    <hr />
                </div>
            </Element>
            <Content props={props} />
        </div>
    );
};

/**
 * Everything under the top bar
 * @param props
 * @returns {*}
 * @constructor
 */
const Content = ({ props }) => {
    const { customNewsletterFormat, newsletterFontFamily } = props;
    const spacerHeight = getSpaceToFillBottom();
    const style = {};

    if (customNewsletterFormat) {
        style.fontFamily = newsletterFontFamily;
    }

    return (
        <main className="nest-content mx-auto" style={style}>
            {/*<div className="row">*/}
            {/*<div className="col">*/}
            {/*<Button onClick={() => props.onNavBarToggled()}>Toggle Nav Bar</Button>*/}
            {/*</div>*/}
            {/*<div className="col text-right">*/}
            {/*<i className="col-1 fas fa-crow fa-5x animated bounce"></i>*/}
            {/*</div>*/}
            {/*</div>*/}
            {/*<Debug props={props} />*/}
            <CustomSections position="top" />

            <NewsletterSections />

            <CustomSections position="bottom" />

            <div
                className="final-spacer"
                style={{ height: `${spacerHeight}px` }}
            />
        </main>
    );
};

/**
 * The top bar
 * @param props
 * @returns {*}
 * @constructor
 */
const TopBar = ({ props }) => {
    const {
        currentArticleScroll,
        currentArticleRavenId,
        currentArticleTitleRaw,
        currentArticleUrl,
        currentArticleUrlRaw,
        isPdfDownloading,
        onToggleSharingMenu,
        isSharingMenuOpen,
        isClipboardCopying,
        accentColor,
        currentArticleScrollLanguage,
        currentArticleScrollLanguageRtl,
        currentArticleOutlet,
        includeFacebook,
        includeTwitter,
        includeLinkedIn,
        includeEmail,
        includeDownloadPdf,
        includeCopyLink,
    } = props;

    const anySelected =
        includeFacebook ||
        includeTwitter ||
        includeLinkedIn ||
        includeEmail ||
        includeDownloadPdf ||
        includeCopyLink;
    const pdfCanvasClassName = isPdfDownloading ? "" : "d-none";
    const buttonsClass = currentArticleUrlRaw ? "" : "disabled";
    return (
        <div className="top-nav-bar">
            {/* Hide the entire top bar content when we do not have an article title */}
            <div className="main-nav-bar">
                <div
                    className="nav-toggle d-block d-md-none btn"
                    onClick={props.onNavBarToggled}
                >
                    <i className="fa fa-bars" />
                </div>
                <div
                    className={`nav-title pl-3 text-truncate ${
                        currentArticleTitleRaw ? "" : "invisible"
                    }`}
                    title={currentArticleTitleRaw}
                    lang={currentArticleScrollLanguage}
                >
                    {currentArticleTitleRaw}
                </div>
                <div
                    className={`nav-links ${
                        currentArticleTitleRaw ? "" : "invisible"
                    }`}
                >
                    {/*<div className="pr-3">*/}
                    {/*<i className="fas fa-crow fa-2x animated bounce"></i>*/}
                    {/*</div>*/}
                    <div className="pr-3">
                        {anySelected && (
                            <button
                                className={`btn btn-light border-0 p-2 white-bg`}
                                id="topBarShareButton"
                                onClick={onToggleSharingMenu}
                            >
                                Share
                            </button>
                        )}
                    </div>
                    <div className="pr-3 view-on-web">
                        <a
                            className={`${buttonsClass} btn btn-light border-0 p-2 white-bg`}
                            id="topBarShareButton"
                            href={currentArticleUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            View on Web
                        </a>
                    </div>
                </div>
            </div>
            <div className="progress row m-0">
                <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                        // transform: `scaleX(${currentArticleScroll/100})`,
                        width: `${currentArticleScroll}%`,
                        backgroundColor: accentColor,
                    }}
                />
                <div
                    className={`${
                        isSharingMenuOpen ? "fadeIn" : "d-none"
                    } top-bar-share-tooltip shadow-lg animated `}
                >
                    {/* Make sure the container in the tooltip is defined otherwise it will not show up correctly */}
                    <SharingTooltipContent props={props} />
                </div>
            </div>
            <span
                className={`notification-area badge badge-secondary animated fadeOut delay-1s slow ${
                    isClipboardCopying ? "" : "d-none"
                }`}
            >
                Copied To Clipboard
            </span>
            <PDFExport
                paperSize="Letter"
                fileName={`${currentArticleOutlet}_${currentArticleTitleRaw}.pdf`}
                scale={0.6}
                margin="2cm"
                title=""
                subject=""
                keywords=""
                ref={(r) => (pdfCanvasReference = r)}
            >
                {isPdfDownloading && (
                    <div
                        style={{
                            padding: "15px",
                            boxShadow: "5px 5px 5px black",
                            height: "3300px",
                            margin: "24px auto",
                            display: "fixed",
                            overflowX: "hidden",
                            overflowY: "hidden",
                        }}
                    >
                        <Article id={currentArticleRavenId} isPdf={true} />
                    </div>
                )}
            </PDFExport>
        </div>
    );
};

/**
 * Trigger a PDF download for the current article
 * @param props
 */
const downloadPdf = (event, props) => {
    // Tried almost everything out there (html2canvas, jspdf, html-to-pdf etc)
    // This is the only that worked
    if (pdfCanvasReference) {
        setTimeout(() => {
            try {
                props.onStartDownloadingPdf();

                pdfCanvasReference.save();

                pingOnDownload({
                    baseUrl,
                    accessToken: props.urlAccessKey,
                    analysisId: props.currentArticleAnalysisId,
                    bestLicense: props.currentArticleBestLicense,
                    licenseFeedUrl: props.currentArticleLicenseFeedUrl,
                })
                    .then((response) => {
                        console.log("Ping successful");
                    })
                    .catch((error) => {
                        console.error("Ping error", error);
                    });
            } finally {
                props.onStopDownloadingPdf();
            }
        }, 1000); // TODO make this better - for now depending on this to guarantee the node is there
    }
};

/**
 * The content of the sharing tooltip
 * @param props
 * @returns {*}
 * @constructor
 */
const SharingTooltipContent = ({ props }) => {
    let {
        currentArticleTitleRaw,
        currentArticleUrlRaw,
        currentArticleOutlet,
        currentArticleExcerptRaw,
        onClipboardCopy,
        onCloseSharingMenu,
        includeFacebook,
        includeTwitter,
        includeLinkedIn,
        includeEmail,
        includeDownloadPdf,
        includeCopyLink,
    } = props;

    const emailSubject = encodeURIComponent(
        `${currentArticleOutlet}: ${currentArticleTitleRaw}`
    );

    let emailBody = encodeURIComponent(`From: ${currentArticleOutlet}:\n\n`);

    if (currentArticleTitleRaw)
        emailBody += encodeURIComponent(`${currentArticleTitleRaw}\n\n`);
    if (currentArticleExcerptRaw)
        emailBody += encodeURIComponent(`${currentArticleExcerptRaw}\n\n`);
    if (currentArticleUrlRaw)
        emailBody += encodeURIComponent(`${currentArticleUrlRaw}\n\n`);

    const emailUrl = `mailto:?subject=${emailSubject}&body=${emailBody}`;

    const urlDependentClass = currentArticleUrlRaw ? "" : "disabled";

    useEffect(() => {
        if (currentArticleUrlRaw) {
            if (window.__sharethis__) {
                window.__sharethis__.initialize();
            }
        }
    }, [currentArticleUrlRaw]);

    return (
        <div className="sharing-icons" onClick={(e) => e.stopPropagation()}>
            {currentArticleTitleRaw && (
                <div>
                    {includeFacebook && (
                        <div className={`shareContainer st-custom-button row ${urlDependentClass}`}
                             data-network="facebook"
                             data-url={currentArticleUrlRaw}
                             data-title=""
                             data-description=""
                             onClick={onCloseSharingMenu}>
                                <i className="col-1 fab fa-facebook-f" />{" "}
                                <span className="col text-left">Facebook</span>
                        </div>
                    )}
                    {includeTwitter && (
                        <div className={`shareContainer st-custom-button row ${urlDependentClass}`}
                             data-network="twitter"
                             data-url={currentArticleUrlRaw}
                             data-title=""
                             data-description=""
                             onClick={onCloseSharingMenu}>
                            <i className="col-1 fab fa-x-twitter"/>{" "}
                            <span className="col text-left">X.com</span>
                        </div>
                    )}
                    {includeLinkedIn && (
                        <div className={`shareContainer st-custom-button row ${urlDependentClass}`}
                             data-network="linkedin"
                             data-url={currentArticleUrlRaw}
                             data-title=""
                             data-description=""
                             onClick={onCloseSharingMenu}>
                                <i className="col-1 fab fa-linkedin" />{" "}
                            <span className="col text-left">LinkedIn</span>
                        </div>
                    )}
                    {includeEmail && (
                        <a
                            href={emailUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`row`}
                            onClick={onCloseSharingMenu}
                        >
                            <i className="col-1 fas fa-envelope" />{" "}
                            <span className="col text-left">Email</span>
                        </a>
                    )}
                    {includeDownloadPdf && (
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`row`}
                            onClick={(event) => downloadPdf(event, props)}
                        >
                            <i className="col-1 fas fa-arrow-alt-down" />{" "}
                            <span className="col text-left">Download PDF</span>
                        </a>
                    )}
                    {includeCopyLink && (
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`row ${urlDependentClass}`}
                            onClick={() =>
                                onClipboardCopy(currentArticleUrlRaw)
                            }
                        >
                            <i className="col-1 far fa-link" />{" "}
                            <span className="col text-left">Copy Link</span>
                        </a>
                    )}
                </div>
            )}
        </div>
    );
};

/**
 * Component to show some state data for debug
 * @param props
 * @returns {*}
 * @constructor
 */
const Debug = ({ props }) => {
    return (
        <div style={{ maxWidth: "100%" }}>
            {/* Debug section */}
            {/*<h2>Selector: <code>getTemplateProperty(state)</code></h2>*/}
            {/*<pre>*/}
            {/*{JSON.stringify(props.sectionFontSize, null, 2)}*/}
            {/*</pre>*/}
        </div>
    );
};

/**
 * mapStateToProps returns the parts of the state that will be available as props
 * @param state
 * @returns {{navigation: *}}
 */
const mapStateToProps = (state, ownProps) => {
    return {
        includeFacebook: shouldIncludeFacebook(state),
        includeTwitter: shouldIncludeTwitter(state),
        includeLinkedIn: shouldIncludeLinkedIn(state),
        includeEmail: shouldIncludeEmail(state),
        includeDownloadPdf: shouldIncludeDownloadPdf(state),
        includeCopyLink: shouldIncludeCopyLink(state),
        newsletterFontFamily: getNewsletterFontFamily(state),
        currentArticleScroll: getCurrentArticleScroll(state, ownProps),
        currentArticleAnalysisId: getCurrentArticleScrollAnalysisId(
            state,
            ownProps
        ),
        currentArticleBestLicense: getCurrentArticleScrollBestLicense(
            state,
            ownProps
        ),
        currentArticleLicenseFeedUrl: getCurrentArticleScrollLicenseFeedUrl(
            state,
            ownProps
        ),
        currentArticleTitle: getCurrentArticleScrollTitle(state, ownProps),
        currentArticleTitleRaw: getCurrentArticleScrollTitleRaw(
            state,
            ownProps
        ),
        currentArticleOutlet: getCurrentArticleScrollOutlet(state, ownProps),
        currentArticleExcerptRaw: getCurrentArticleScrollExcerptRaw(
            state,
            ownProps
        ),
        currentArticleUrl: getCurrentArticleScrollUrl(state, ownProps),
        currentArticleUrlRaw: getCurrentArticleScrollRawUrl(state, ownProps),
        currentArticleRavenId: getCurrentArticleIdBeingScrolled(
            state,
            ownProps
        ),
        currentArticleDomNode: getCurrentArticleDomNode(state, ownProps),
        currentArticleScrollLanguageRtl:
            getCurrentArticleScrollLanguageisRightToLeft(state, ownProps),
        currentArticleScrollLanguage: getCurrentArticleScrollLanguage(
            state,
            ownProps
        ),
        isPdfDownloading: getIsPdfDownloading(state),
        isSharingMenuOpen: getIsSharingMenuOpen(state),
        isClipboardCopying: getIsClipboardCopying(state),
        accentColor: getNewsletterAccentColor(state),
        customNewsletterFormat: getNewsletterUseCustomFormat(state),
        routerStateHashArticleGroupingId:
            getRouterStateHashArticleGroupingId(ownProps),
        isNavBarOpen: getIsNavBarOpen(state),
        isMobile: isMobile(),
        urlAccessKey: getUrlAccessKey(state),
    };
};

/**
 * mapDispatchToProps exposes the actions we want to call as props
 * @param state
 * @returns {{navigation: *}}
 */
const mapDispatchToProps = (dispatch) => {
    return {
        onNavBarToggled: () => {
            dispatch(navBarToggle());
        },
        onStopDownloadingPdf: () => {
            dispatch(stopDownloadingPdf());
        },
        onStartDownloadingPdf: () => {
            dispatch(startDownloadingPdf());
            dispatch(closeSharingMenu());
        },
        onContentClicked: () => {
            dispatch(closeSharingMenu());
        },
        onToggleSharingMenu: (event) => {
            event.preventDefault();
            event.stopPropagation();
            dispatch(toggleSharingMenu());
        },
        onOpenSharingMenu: () => {
            dispatch(openSharingMenu());
        },
        onCloseSharingMenu: () => {
            dispatch(closeSharingMenu());
        },
        onClipboardCopy: (value) => {
            dispatch(copyToClipboard(value));
            dispatch(closeSharingMenu());
        },
    };
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ContentPane)
);
